module.exports = __webpack_public_path__ + "img/pixel_email.840ba8d4.svg";